import { Pipe, PipeTransform } from '@angular/core';
import { ApiDocumentProcessModel } from '../core/models/api-document-process.model';
import { FilterDocumentModel } from '../core/models/filter-document.model';

@Pipe({
  name: 'documentFilter'
})
export class DocumentFilterPipe implements PipeTransform {

  transform(values: ApiDocumentProcessModel[], ...args:any[]): ApiDocumentProcessModel[] {
    if(!Array.isArray(values))
    {
      return values;
    }

    const [query, ...properties]:any[] = args;
    let changed = new Boolean(false);
    const piece = args.slice(0, 6)


    var filtered = piece.filter(e => e != null || e != '');
    if(filtered.length > 0)
    {
      changed= true;

    }

    if(changed == false) return values;
    else{


    if(properties[5].constancyType !== null)
    {

      values= values.filter(x=>  x.constancyType == properties[5].constancyType)
    }
    if(properties[5].sintraId !== '')
    {
      values = values.filter(x=> x.documentProcessTos.find(y=> y.sintraId == properties[5].sintraId));
    }

    if(properties[5].status !== null)
    {
      values = values.filter(x=> x.documentProcessStatus == properties[5].status);
    }

    values.forEach((item) => {
      new Date(item.documentProcessUpdateDate).toLocaleDateString('en-US');
    });

    if(properties[5].startDate != null && properties[5].endDate != null)
    {
      
      values = values.filter(
        x=> x.documentUploadDate >= properties[5].startDate && x.documentUploadDate <= properties[5].endDate
      );
      
    }

    if(properties[5].startDate == null && properties[5].endDate != null)
    {

      values = values.filter(x=> x.documentUploadDate <= properties[5].endDate);
    }

    if(properties[5].startDate != null && properties[5].endDate == null)
    {
      values = values.filter(x=> x.documentUploadDate >= properties[5].startDate.toString());
    }

    return values;
         }

   }


}
